<template>
    <div class="partic">
        <van-overlay className="taskLoading" :show="loading || loadingApply" >
            <div class="wrapper" @click.stop>
                <van-loading color="#0094ff" vertical></van-loading>
            </div>
        </van-overlay>
        <div>
            <div class="info">
                <div class="title">
                    参与人邀请<span v-if="syncState !== 2">（{{ syncState === 1 ? '已同意' : '已拒绝' }}）</span>
                </div>
                <van-divider class="divider" />
                <div class="content">
                    <div class="info">
                        <van-image class="image" round fit="cover" lazy-load :src="messageInfo.userInfo ? messageInfo.userInfo.UserIcon : ''" />
                        <div class="name">{{ messageInfo.userInfo ? messageInfo.userInfo.UserName : '' }}</div>
                    </div>
                    <div class="text">{{ messageInfo.content }}</div>
                </div>
            </div>
            <div class="card">
                <div class="title">{{ messageInfo.itemName }}</div>
                <div class="content">
                    <div class="item">
                        <div class="label">创建于</div>
                        <div class="value">{{ messageInfo.createTime }}</div>
                    </div>
                    <div class="item">
                        <div class="label">有效期</div>
                        <div class="value">[{{ messageInfo.startTime }}] - [{{ messageInfo.endTime }}]</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="foot" v-if="syncState === 2">
            <van-button class="btn jj" type="default" round size="large" @click="click(0)">拒 绝</van-button>
            <van-button class="btn" type="primary" round size="large" @click="click(1)">同 意</van-button>
        </div>
    </div>
</template>

<script lang="ts">
import { computed, onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';

export default {
    setup() {
        const store = useStore();
        const calendar = store.state.calendar;
        const router = useRoute();
        const messageId = router.params.messageId;
        const loadingApply = ref(false);

        onMounted(() => {
            store.dispatch('calendar/GET_SYNC_MEMBER_MESSAGES', { messageId });
        });

        const loading = computed(() => calendar.loadingSycnMemeber);
        const messageInfo = computed(() => calendar.sycnMemeberInfo);
        const syncState = computed(() => calendar.syncState);

        const click = (type: number) => {
            const action = type === 1 ? 'calendar/SCHEDULE_INVITATION_AGREED' : 'calendar/SCHEDULE_INVITATION_REFUSED';
            loadingApply.value = true;
            store.dispatch(action, { messageId }).finally(() => {
                loadingApply.value = false;
            });
        };

        return {
            loading,
            loadingApply,
            messageInfo,
            click,
            syncState,
        };
    },
};
</script>

<style lang="less" scoped>
.partic {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .info {
        padding: 0 16px 16px 16px;
        background: #fff;
        .title {
            height: 48px;
            font-size: 18px;
            font-weight: 500;
            color: #333;
            line-height: 48px;
        }
        .divider {
            margin: 0;
            height: 1px;
            font-weight: 500;
            background: #ebedf0;
        }
        .content {
            font-size: 16px;
            font-weight: 400;
            .info {
                display: flex;
                padding: 12px 0;
                .image {
                    width: 40px;
                    height: 40px;
                }
                .name {
                    color: #333;
                    line-height: 40px;
                    margin-left: 8px;
                }
            }
            .text {
                color: #666;
            }
        }
    }
    .card {
        margin-top: 10px;
        padding: 12px 16px;
        background: #fff;
        .title {
            font-size: 16px;
            font-weight: 400;
            color: #323233;
        }
        .content {
            .item {
                display: flex;
                flex-direction: row;
                margin-top: 12px;
                font-size: 14px;
                font-weight: 400;
                .label {
                    width: 45px;
                    color: #969799;
                    margin-right: 12px;
                }
                .value {
                    flex: 1;
                    color: #646566;
                }
            }
        }
    }
}
.foot {
    display: flex;
    justify-content: space-between;
    padding: 16px;
    .btn {
        width: 166px;
        height: 44px;
    }
    .btn.jj {
        color: #ff7875;
    }
}

.taskLoading {
    position: fixed;
    z-index: 999;
    top: 0;
    left: 0;
    .wrapper {
        height: 100vh;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}
</style>
